import React from 'react';
import strings from './strings.js';

import { useNavigate, useLocation } from 'react-router-dom';

import icoDel from './img/ico-del.svg';
import localForage from "localforage";
import icoInsert from './img/insert.svg';
import icoDownload from './img/ico-download.svg';
import icoProhibited from './img/ico-prohibited.svg';
import progressCircle from './img/progressCircle.gif';
import { SendMessage, socket } from './App.js';

const API_URL = "https://starboxkod.com/api";

const SongCard = ({ cookieFavs, setCookieFavs, mode, song, onClick, innerRef, lang,setSelectedSinger, onClick2,/*following is for the list */ index, List, Rec, tableNo, stateVer, downloadingInProgress, setDownloadingInProgress } ) => {
    const navigate = useNavigate()
    const location = useLocation();


    const handleSingerClick = (singerName, e) => {
        e.stopPropagation(); // Stop event propagation here
        // Define your functions here to handle each singer click
        // For example:

        /*
        console.log("hiiii");
        if (List) {
            return;
        }
        if (Rec) {
            return;
        }
        if (location.pathname !== "/home/artists/singer" && location.pathname !== "/admin/artists/singer") {
            if (location.pathname == "/admin/songs") {
                navigate("/admin/artists/singer");
                //navigate("/admin/artists/singer", {replace:true});
            } else {
                navigate("/home/artists/singer");
                //navigate("/home/artists/singer", {replace:true});
            }
            console.log(song);
            setSelectedSinger(singerName);
        }

        */

        if (location.pathname === "/home/songs") {
            navigate("/home/artists/singer");
            //navigate("/home/songs/singer");
            setSelectedSinger(singerName);
        }
    };
    



    return (
        <div className="song-panel"  onClick={onClick} ref={innerRef}>
            <div onClick={(e) => {e.preventDefault();}}>
                <img className="song-panelPhoto"
                    src={`${API_URL}/profile-image/${song.singer}`}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src="https://via.placeholder.com/100";
                    }}
                    alt={song.song_name}/>
            </div>



            
            <div className="song-panelText"              style={{flexGrow:10, flexBasis:0}}>
                <div className="song-panelName">{song.song_name}</div>
                <div className="song-panelArtists">
                <div className="song-panelArtist">
                    {/* Singer 1 */}
                    <span onClick={(e) => handleSingerClick(song.singer, e)}>
                        {song.singer}
                    </span>
                    {/* Singer 2 */}
                    {song.singer2 && (
                        <span onClick={(e) => handleSingerClick(song.singer2, e)}>
                            {`, ${song.singer2}`}
                        </span>
                    )}
                    {/* Singer 3 */}
                    {song.singer3 && (
                        <span onClick={(e) => handleSingerClick(song.singer3, e)}>
                            {`, ${song.singer3}`}
                        </span>
                    )}
                </div>
                </div>
            </div>

            {mode === 222222222 && ( //Favourites HERE MODE === 2 BUT I TEMP SET TO RANDOM VALUE
                <a onClick={(e) => {e.preventDefault(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation();
                    localForage.getItem("favs").then(function(value) {
                        localForage.setItem("favs", value.filter(color => color.song_num !== song.song_num)).then(
                            onClick2()
                        )
                    });
    
                            }}>
                    <img className="song-panelDelete" style={{height:"20px",marginLeft:"8px"}}
                            src={icoDel}                       
                            alt={song.song_name}/>
                </a>
            )}
            

            {(List) && (((stateVer==="wangluo")&&(index > 1))||((stateVer==="danji")&&(index > 0))) && (
            <a className="song-panelDownload" style={{height:"20px"}} alt="Insert" onClick={(e) => {e.preventDefault();
                SendMessage(`[{"type":"HALL_INSERT_SONG","tableId":"t1","index":${index}}]`);}}>
                <img src={icoInsert} alt="ListInsert" style={{height:"20px"}}/>
            </a>
            )}

            {List && ((stateVer==="wangluo")&&(index == 0)) &&  (
                <div className="song-panelText">
                    <div className="song-panelLanguage" style={{color: "#3751fe", fontWeight:500}}>{lang ? strings.cn.nowPlaying : strings.en.nowPlaying}</div>
                </div>
            )}

            <div className="song-panelText" style={{flexGrow:5, flexBasis:0}}>
                <div className="song-panelSongcode">{song.song_num}</div>
                <div className="song-panelLanguage">{lang ? strings.cn[song.language] : strings.en[song.language]}</div>
            </div>

            {List && (((stateVer==="wangluo")&&(index > 0))||(stateVer==="danji")) &&  (
                    <a onClick={(e) => {e.preventDefault();
                        SendMessage(`[{"type":"HALL_DELETE_SONG","tableId":"t1","index":${index}}]`);}}>
                    <img className="song-panelDelete" style={{height:"20px",marginLeft:"8px"}} alt="ListDelete" src={icoDel}
            />
            </a>
            )}

            {Rec && (
            <a className="song-panelDownload" style={{height:"20px"}} alt={song.song_name} onClick={(e) => {e.preventDefault();
                    if (downloadingInProgress == -1) { //if nothing is currently downloading already, allow user to initiate download
                        SendMessage(`[{"type":"REC_REQ","tableId":"t${tableNo}","index":${index},"userId":"${socket.id}"}]`);
                        setDownloadingInProgress(index); //identify which index is downloading
                    }                
                }}
                ><img src={downloadingInProgress == -1 ? icoDownload : downloadingInProgress == index ? progressCircle : icoProhibited} style={{height:"20px", width:"20px"}} />
            </a>
            )}





        </div>
    );
}

export default SongCard;